import { type HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { DEMO_OUTBOX_HEADER, DEMO_REAL_EMAIL_HEADER, decodeDemoOutbox } from '@arya/shared/dev-accounts';

import { tap } from 'rxjs';

import { DemoOutbox } from './demo-outbox';

export const demoOutboxInterceptor: HttpInterceptorFn = (request, next) => {
  const outbox = inject(DemoOutbox);
  const sent = outbox.realEmail() ? request.clone({ setHeaders: { [DEMO_REAL_EMAIL_HEADER]: '1' } }) : request;
  return next(sent).pipe(
    tap((event) => {
      if (event instanceof HttpResponse)
        outbox.record(decodeDemoOutbox(event.headers.get(DEMO_OUTBOX_HEADER) ?? undefined), new Date());
    })
  );
};
